import { Component } from "react";
import { Link } from "react-router-dom";
import Header from "../components/header";
import Footer from "../components/footer";

import "../styles/auth.css";
import UserService from "../services/user_service";
import { toast } from "react-toastify";

class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      password: "",
      errorMessage: "",
    };
  }

  handleChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
      errorMessage: "",
    });
  };

  handleSubmit = (e) => {
    e.preventDefault();

    const { email, password } = this.state;

    if (!email.trim() || !password.trim()) {
      this.setState({
        errorMessage: "Please fill in both your email and password.",
      });
      return;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      this.setState({ errorMessage: "Please enter a valid email address." });
      return;
    }

    UserService.login({
      email: email,
      password: password,
    })
      .then((res) => {
        if (res.data.success) {
          localStorage.setItem("user", JSON.stringify(res.data.user));
          window.location.href = "/";
          toast.success("Login Successful");
        } else {
          toast.error(res.data.message || "Login Failed");
        }
      })
      .catch((err) => {
        console.error(err);
        toast.error("Invalid Email or Password");
      });

    console.log("Ready to authenticate:", { email, password });
  };

  render() {
    const { isLoggedIn } = this.props;
    return (
      <div className="d-flex flex-column min-vh-100 bg-light">
        <Header isLoggedIn={isLoggedIn} />

        <main className="flex-grow-1 d-flex justify-content-center align-items-center py-5">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-12 col-md-8 col-lg-5">
                <div className="card shadow-sm border-0 rounded-4 auth-card">
                  <div className="card-body p-4 p-md-5">
                    <div className="text-center mb-4">
                      <h2 className="fw-bold text-dark mb-2">Welcome Back</h2>
                      <p className="text-secondary">
                        Log in to your XLP account
                      </p>
                    </div>

                    {this.state.errorMessage && (
                      <div
                        className="alert alert-danger py-2"
                        style={{ fontSize: "14px" }}
                        role="alert"
                      >
                        {this.state.errorMessage}
                      </div>
                    )}

                    <form onSubmit={this.handleSubmit}>
                      <div className="mb-3">
                        <label className="form-label fw-medium text-dark">
                          Email Address
                        </label>
                        <input
                          type="email"
                          name="email"
                          className="form-control form-control-lg bg-light custom-input"
                          placeholder="name@example.com"
                          value={this.state.email}
                          onChange={this.handleChange}
                        />
                      </div>

                      <div className="mb-4">
                        <div className="d-flex justify-content-between align-items-center">
                          <label className="form-label fw-medium text-dark mb-0">
                            Password
                          </label>
                          <Link
                            to="/forgot-password"
                            className="text-brand text-decoration-none"
                            style={{ fontSize: "14px" }}
                          >
                            Forgot password?
                          </Link>
                        </div>
                        <input
                          type="password"
                          name="password"
                          className="form-control form-control-lg bg-light custom-input mt-2"
                          placeholder="Enter Password"
                          value={this.state.password}
                          onChange={this.handleChange}
                        />
                      </div>

                      <button
                        type="submit"
                        className="btn btn-brand btn-lg w-100 mb-3"
                      >
                        Log In
                      </button>

                      <div className="text-center">
                        <span className="text-secondary">
                          Don't have an account?{" "}
                        </span>
                        <Link
                          to="/sign_up_screen"
                          className="text-brand text-decoration-none fw-medium"
                        >
                          Sign up
                        </Link>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>

        <Footer />
      </div>
    );
  }
}

export default Login;
